module.exports = __webpack_public_path__ + "static/media/icra24haroldspeech.59104335.jpeg";